import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ColorTagComponent } from '@shared/components/color-tag/color-tag.component';
import { DividerComponent } from '@shared/components/divider/divider.component';
import { IsNewTagComponent } from '@shared/components/is-new-tag/is-new-tag.component';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { IRelatedItems_Item } from '@shared/constants/models.const';
import { NgClass } from '@angular/common';
import { HelperService } from '../../../services/helper.service';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyDate } from '@shared/pipes/only-date';

@Component({
  selector: 'app-related-item',
  imports: [
    ColorTagComponent,
    DividerComponent,
    IsNewTagComponent,
    RemoveHtmlPipe,
    NgClass,
    TranslateModule,
    OnlyDate,
  ],
  templateUrl: './related-item.component.html',
  styleUrl: './related-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemComponent {
  relatedItem = input.required<IRelatedItems_Item>();
  isLast = input<boolean>(false);
  description = computed(() => {
    return this.relatedItem().summary || this.relatedItem().description;
  });


  constructor(
    public HELPER: HelperService,
  ) {}

}
